import * as Y from 'yjs';

import { WidgetType } from 'shared/widgets/utils';

import { manifestLocales } from './manifest.locales';
import { createNewOpenQuestionAnswerData } from '@/contentObjects/OpenQuestionAnswer/create';
import { InitializePropsOptions, ManifestInitializedProps } from '@/types/ManifestType';
import { genRandId } from '@/utils/core.utils';
import { htmlToXmlFragment } from '@/utils/tiptap';
import { TextEditorTypes } from '@/widgets/OpenQuestion/OpenQuestion.utils';
import { getEvaluationProps } from '@/widgets/consts/getEvaluationProps';
import { createQuestionWidgetChildren } from '@/widgets/utils/createQuestionWidgetChildren';

export function createNewOpenQuestionData(options: InitializePropsOptions): ManifestInitializedProps {
  const { isPlenaryLesson, locale } = options;
  const { initialHeadlineText, answerPlaceholder } = manifestLocales.openQuestion;

  const id = genRandId();
  const labelFragment = htmlToXmlFragment(`<h2><span>${initialHeadlineText[locale]}</span></h2>`);
  const placeholderFragment = htmlToXmlFragment(answerPlaceholder[locale]);
  const hintFragment = htmlToXmlFragment('<p></p>');
  const widgetEvaluationProps = Object.entries(getEvaluationProps(isPlenaryLesson));

  const [questionAnswerData] = createNewOpenQuestionAnswerData();
  const { childrenArray, horizontalFlexSectionData, verticalFlexSectionData } = createQuestionWidgetChildren(
    questionAnswerData.id,
    options?.width
  );

  return [
    {
      id,
      contentObjectData: new Y.Map([
        ['id', id],
        ['type', WidgetType.OpenQuestion],
        ['children', childrenArray],
        ['labelFragment', labelFragment],
        ['placeholderFragment', placeholderFragment],
        ['hintFragment', hintFragment],
        ['saveAnswers', true],
        ['textEditorType', TextEditorTypes.Simple],
        [
          'showElements',
          {
            text: true,
            recording: false,
            image: false,
            file: false,
            embed: false
          }
        ],
        ...widgetEvaluationProps,
        ['showAnswerButton', false], //override default value
        ['questionAnswerId', questionAnswerData.id]
      ])
    },
    verticalFlexSectionData,
    horizontalFlexSectionData,
    questionAnswerData
  ];
}
